import Circular from "./Circular.jsx";

export default {
  Circular,
};
